import { Extension } from "@tiptap/core";

export const BackgroundColor = Extension.create({
  name: "backgroundColor",

  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (element) => {
              const color = element.style.backgroundColor;
              return color.replace(/['"]+/g, "");
            },
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor) {
                return {};
              }
              return {
                style: `background-color: ${attributes.backgroundColor}`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setBackgroundColor: (color) => ({ chain }) => {
        return chain().setMark("textStyle", { backgroundColor: color }).run();
      },

      unsetBackgroundColor: () => ({ chain }) => {
        return chain()
          .setMark("textStyle", { backgroundColor: null })
          .removeEmptyTextStyle()
          .run();
      },
    };
  },
});
